import { dew as _context2Dew } from "./context";
import * as _types2 from "@babel/types";
var _types = "default" in _types2 ? _types2.default : _types2;
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.traverseNode = traverseNode;
  var _context = _context2Dew();
  var _t = _types;
  const {
    VISITOR_KEYS
  } = _t;
  function traverseNode(node, opts, scope, state, path, skipKeys) {
    const keys = VISITOR_KEYS[node.type];
    if (!keys) return false;
    const context = new _context.default(scope, opts, state, path);
    for (const key of keys) {
      if (skipKeys && skipKeys[key]) continue;
      if (context.visit(node, key)) {
        return true;
      }
    }
    return false;
  }

  //# sourceMappingURL=traverse-node.js.map
  return exports;
}